import * as Vuex from "vuex";
import { CSVTagResponse, CSVFile } from "@/entities/tagCSV";
import { httpByCurrentCustomer } from "@/lib/client";

const tagCSVModule: Vuex.Module<TagCSVState, {}> = {
  state: {
    CSVTagResponseUpdate: [],
  },
  mutations: {
    SET_CSV_TAG_UPDATE(state, payload: CSVTagResponse[]) {
      state.CSVTagResponseUpdate = payload;
    },
  },
  actions: {
    // Upload CSV File
    async upploadCSV({ commit }, file: CSVFile) {
      const response = await httpByCurrentCustomer()
        .put("calls/csv", { body: file })
        .json<CSVTagResponse>();
      commit("SET_CSV_TAG_UPDATE", response);
    },
  },
  namespaced: true,
};

type TagCSVState = {
  CSVTagResponseUpdate: CSVTagResponse[];
};
export default tagCSVModule;
